import AppRouter from "./router/AppRouter";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
      <AppRouter />
    </>
  );
}

export default App;
